<template>
  <div>
    <div class="p-a white lt box-shadow">
      <p class="m-b-0 inline">
        <a :href="indexUrl">Pricebook</a> 
        <span class="text-muted"> / {{ pricebook.name }}</span>
      </p>
      <a
        v-if="canManagePricebooks"
        :disabled="onLoading('save-pricebook')" 
        :href="indexUrl"
        class="nav-link pull-right">
        <i class="material-icons">keyboard_arrow_left</i>
        <span>Pricebook List</span>
      </a>
    </div>

    <v-loading
      class="text-center text-lg"
      loader="fetch-pricebook"/>

    <div 
      v-if="!onLoading('fetch-pricebook')" 
      class="padding">
      <div class="row">

        <!-- General -->
        <div class="col-md-3 push-md-9">
          <div class="box">
            <div class="box-header b-b">
              <h3>General</h3>
            </div>
            <div class="box-body p-b-0">

              <!-- input name -->
              <div 
                :class="{'invalid':errors.has('name')}" 
                class="form-group">
                <label>Name</label>
                <input 
                  v-validate="'required'" 
                  :value="pricebook.name"
                  :disabled="onLoading('save-pricebook')" 
                  type="text" 
                  class="form-control" 
                  name="name"
                  placeholder="Required"
                  @input="setPricebookAttr({ key: 'name', value: $event.target.value })">                        
                <span 
                  v-show="errors.has('name')" 
                  class="form-error-msg">{{ errors.first('name') }}</span>
              </div>
            </div>

            <!-- outlete selector -->
            <div class="box-body p-t-xs">
              <label class="multiselect-label">Outlets</label>
              <multi-outlet-selector
                :value="pricebook.outlets"
                v-model="outlets"
                :include-only="allowedOutlets"/>
            </div>

            <div
              v-if="canManagePricebooks"
              class="box-footer b-t text-right">
              <button 
                :disabled="onLoading('save-pricebook')" 
                :class="{ 'white': !isDirty, 'primary': isDirty }"
                class="btn m-b-0 w-xs"
                @click="submit">
                <v-loading loader="save-pricebook">Save</v-loading>
              </button>
            </div>
          </div>
        </div>

        <!-- Product List -->
        <div class="col-md-9 m-b-sm">
          <product-list 
            :id="id"
            :show-import="showImportForm"
          />
        </div>

        <import-pricebook :pricebook-id="id"/>

      </div>
    </div>
  </div>
</template>

<script>
import pricebookModule from '@js/store/modules/pricebook';
import PermissionMixin from './pricebook-permission';
import productList from './pricebook-products.vue';
import { mapActions, mapGetters } from 'vuex';
import importPricebook from './import/import-pricebook';

export default {
    components: {
        productList,
        importPricebook,
    },

    mixins: [PermissionMixin],

    props: {
        id: {
            type: Number,
            required: true,
        },

        allowedOutlets: {
            type: Array,
            required: true,
        },
    },

    computed: {
        ...mapGetters('pricebook', ['pricebook', 'products', 'original']),

        isDirty() {
            return (
                JSON.stringify(this.pricebook) !== JSON.stringify(this.original)
            );
        },

        indexUrl() {
            return Laroute.route('franchise.inventory.pricebook.index');
        },

        outlets: {
            get() {
                return this.pricebook.outlets;
            },
            set(value) {
                this.setPricebookAttr({ key: 'outlets', value });
            },
        },
    },

    beforeCreate() {
        this.$store.registerModule('pricebook', pricebookModule);
    },

    created() {
        this.getPricebook(this.id);
    },

    mounted() {
        window.onbeforeunload = e => {
            if (this.isDirty) {
                var dialogText = 'Changed you made might not be saved';
                e.returnValue = dialogText;
                return dialogText;
            }
        };
    },

    methods: {
        ...mapActions('pricebook', [
            'getPricebook',
            'updatePricebook',
            'setPricebookAttr',
        ]),

        async submit() {
            if (!(await this.$validator.validateAll())) return;

            try {
                await this.updatePricebook();
                this.showToastrSuccess('Pricebook has been successfully saved');
            } catch (e) {
                this.showApiError(e);
            }
        },

        showImportForm() {
            $('#import-pricebook').modal('show');
        },
    },
};
</script>

<style lang="scss">
@import '../../../../sass/common/input';
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/pricebook/pricebook.vue